module.exports = __webpack_public_path__ + "static/media/final-j-171-bet-el-watan-shot-2.cfea7621.webp";